import { useState } from "react";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://uibgpqgajbznxatdamzx.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVpYmdwcWdhamJ6bnhhdGRhbXp4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5MTAwOTIsImV4cCI6MjA5MTQ4NjA5Mn0.r38ihHY0ohac0brSFc623rbAIAmi0M9Yxu3sTJnm_bg"
);

export default function AdminDashboard() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleSend = async () => {
    if (!title || !body) {
      setError("Title and message are required");
      return;
    }

    setLoading(true);
    setResult(null);
    setError(null);

    try {
      const { data, error } = await supabase.functions.invoke(
        "dynamic-action",
        {
          body: { title, body },
        }
      );

      if (error) throw error;

      setResult(`Successfully sent to ${data.sent} users`);
      setTitle("");
      setBody("");
    } catch (err) {
      setError("Failed to send notification");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: "40px auto", padding: "0 16px" }}>
      <h1>Send Notification</h1>

      {result && (
        <div style={{
          padding: 12,
          marginBottom: 16,
          background: "#e6f4ea",
          borderRadius: 8,
          color: "#2d6a4f"
        }}>
          ✅ {result}
        </div>
      )}

      {error && (
        <div style={{
          padding: 12,
          marginBottom: 16,
          background: "#fce8e8",
          borderRadius: 8,
          color: "#c0392b"
        }}>
          ❌ {error}
        </div>
      )}

      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>
          Title
        </label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g. New feature available!"
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: 8,
            border: "1px solid #ddd",
            fontSize: 14,
            boxSizing: "border-box"
          }}
        />
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>
          Message
        </label>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="e.g. Check out the new study materials we just added!"
          rows={4}
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: 8,
            border: "1px solid #ddd",
            fontSize: 14,
            resize: "vertical",
            boxSizing: "border-box"
          }}
        />
      </div>

      <button
        onClick={handleSend}
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px",
          background: loading ? "#ccc" : "#4f46e5",
          color: "white",
          border: "none",
          borderRadius: 8,
          fontSize: 16,
          fontWeight: 500,
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Sending..." : "Send to All Users"}
      </button>
    </div>
  );
}